import { useDispatch, useSelector } from 'react-redux';
import { addToCart as addToCartAction } from '@src/store/cart';

export const useAddToCart = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);

  const addToCart = (id) => {
    dispatch(addToCartAction(id, user));
  };

  return { addToCart };
};

export const useCart = () => {
  const miniCart = useSelector((state) => new Set(state.cart.miniCart));
  const ownedProducts = useSelector((state) => new Set(state.cart.ownedProducts));

  return { miniCart, ownedProducts };
};
